/**
 * PRODUCT GALLERY — VF-AD-gallery.js
 * Place in: assets/VF-AD-gallery.js
 *
 * Uses Shopify's AJAX API to load collection products.
 * Reads extra gallery media from product metafields:
 *   Namespace: "gallery"
 *   Keys:      "images"  (type: list.file_reference)
 *              "videos"  (type: list.file_reference  OR  text for YouTube/Vimeo embed URLs)
 */

(function () {
  'use strict';

  /* --------------------------------------------------------
     STATE
  -------------------------------------------------------- */
  const state = {
    activeCatId: null,
    activeSubHandle: null,
    activeSubLabel: null,
    lbProduct: null,   // { title, media: [{type, url, thumbUrl}] }
    lbIndex: 0,
  };

  /* --------------------------------------------------------
     CATEGORY TOGGLE
  -------------------------------------------------------- */
  window.vfadToggleCat = function (btn, catId) {
    const wasOpen = btn.getAttribute('aria-expanded') === 'true';

    // Close all
    document.querySelectorAll('.vfad-cat__header').forEach(b => {
      b.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('.vfad-cat__subs').forEach(el => {
      el.hidden = true;
    });

    if (!wasOpen) {
      btn.setAttribute('aria-expanded', 'true');
      document.getElementById('vfad-subs-' + catId).hidden = false;
      state.activeCatId = catId;

      // Auto-select first sub
      const firstSub = document.querySelector(`#vfad-subs-${catId} .vfad-subcat`);
      if (firstSub) firstSub.click();
    } else {
      state.activeCatId = null;
      state.activeSubHandle = null;
      vfadShowHomeView();
    }
  };

  /* --------------------------------------------------------
     SUBCATEGORY SELECT
  -------------------------------------------------------- */
  window.vfadSelectSub = function (btn, handle) {
    document.querySelectorAll('.vfad-subcat').forEach(b => b.classList.remove('is-active'));
    btn.classList.add('is-active');
    state.activeSubHandle = handle;
    state.activeSubLabel = btn.querySelector('.vfad-subcat__name').textContent.trim();
    loadProducts(handle);
  };

  /* --------------------------------------------------------
     VIEWS
  -------------------------------------------------------- */
  function vfadShowHomeView() {
    document.getElementById('vfad-home').style.display = '';
    document.getElementById('vfad-products').style.display = 'none';
  }

  function showProductsView() {
    document.getElementById('vfad-home').style.display = 'none';
    document.getElementById('vfad-products').style.display = '';
  }

  /* --------------------------------------------------------
     LOAD PRODUCTS via Shopify AJAX API
  -------------------------------------------------------- */
  function loadProducts(collectionHandle) {
    showProductsView();

    const titleEl = document.getElementById('vfad-products-title');
    const subEl = document.getElementById('vfad-products-sub');
    const gridEl = document.getElementById('vfad-grid');
    const breadEl = document.getElementById('vfad-breadcrumb');

    titleEl.textContent = state.activeSubLabel;
    subEl.textContent = 'Loading…';
    gridEl.innerHTML = '<div class="vfad-loading">Loading products…</div>';
    breadEl.innerHTML = `
      <button onclick="vfadShowHomeView()">Gallery</button>
      <span class="sep">›</span>
      <span>${state.activeSubLabel}</span>
    `;

    // Fetch collection products (up to 250)
    fetch(`/collections/${collectionHandle}/products.json?limit=250`)
      .then(r => r.json())
      .then(data => renderProductGrid(data.products))
      .catch(() => {
        gridEl.innerHTML = '<div class="vfad-loading">Could not load products. Please try again.</div>';
      });
  }

  function renderProductGrid(products) {
    const gridEl = document.getElementById('vfad-grid');
    const subEl = document.getElementById('vfad-products-sub');

    if (!products || products.length === 0) {
      gridEl.innerHTML = '<div class="vfad-loading">No products found in this category.</div>';
      subEl.textContent = '0 products';
      return;
    }

    subEl.textContent = `${products.length} product${products.length !== 1 ? 's' : ''} — click any product to view its photos & videos`;

    gridEl.innerHTML = products.map((p, i) => {
      const thumb = p.images && p.images.length > 0
        ? p.images[0].src
        : 'data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><rect fill="%23f0ece4" width="100" height="100"/><text x="50" y="55" text-anchor="middle" font-size="32">📦</text></svg>';

      // Count gallery metafield media (approximate - full count loaded on click)
      const baseCount = p.images ? p.images.length : 0;

      return `
        <div class="vfad-product-card" onclick="vfadOpenLightbox(${i})" data-product-index="${i}">
          <div class="vfad-product-card__thumb">
            <img src="${escHtml(thumb)}" alt="${escHtml(p.title)}" loading="lazy">
            <div class="vfad-product-card__badge">${baseCount} photo${baseCount !== 1 ? 's' : ''}</div>
          </div>
          <div class="vfad-product-card__info">
            <div class="vfad-product-card__name">${escHtml(p.title)}</div>
            <div class="vfad-product-card__meta">
              <span>📷 ${baseCount}</span>
            </div>
          </div>
        </div>
      `;
    }).join('');

    // Store products on the grid for lightbox access
    gridEl._products = products;
  }

  /* --------------------------------------------------------
     LIGHTBOX
  -------------------------------------------------------- */
  window.vfadOpenLightbox = function (productIndex) {
    const gridEl = document.getElementById('vfad-grid');
    const product = gridEl._products[productIndex];
    if (!product) return;

    // Build media array from Shopify product images
    const media = (product.images || []).map(img => ({
      type: 'image',
      url: img.src.replace(/(\.[^.]+)$/, '_1200x$1'),  // larger version
      thumbUrl: img.src.replace(/(\.[^.]+)$/, '_120x$1'),
    }));

    // Append gallery metafield videos if present
    // These come from product.metafields (requires Storefront API or liquid injection)
    // We check for a data attribute injected by Liquid
    const card = document.querySelector(`[data-product-index="${productIndex}"]`);
    if (card && card.dataset.galleryVideos) {
      try {
        const vids = JSON.parse(card.dataset.galleryVideos);
        vids.forEach(v => media.push({ type: 'video', url: v, thumbUrl: null }));
      } catch (e) {}
    }

    state.lbProduct = { title: product.title, media };
    state.lbIndex = 0;
    renderLightbox();

    const lb = document.getElementById('vfad-lightbox');
    lb.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  };

  window.vfadCloseLightbox = function () {
    document.getElementById('vfad-lightbox').style.display = 'none';
    document.body.style.overflow = '';
    // Stop any playing video
    const stage = document.getElementById('vfad-lb-stage');
    const video = stage.querySelector('video');
    if (video) video.pause();
  };

  window.vfadLbNav = function (dir) {
    const total = state.lbProduct.media.length;
    state.lbIndex = (state.lbIndex + dir + total) % total;
    renderLightbox();
  };

  function renderLightbox() {
    const { title, media } = state.lbProduct;
    const i = state.lbIndex;
    const item = media[i];

    document.getElementById('vfad-lb-title').textContent = title;
    document.getElementById('vfad-lb-counter').textContent = `${i + 1} / ${media.length}`;

    // Stage
    const stage = document.getElementById('vfad-lb-stage');
    if (item.type === 'image') {
      stage.innerHTML = `<img src="${escHtml(item.url)}" alt="${escHtml(title)} - photo ${i + 1}">`;
    } else if (item.type === 'video') {
      if (item.url.includes('youtube.com') || item.url.includes('youtu.be')) {
        const vidId = item.url.match(/(?:v=|youtu\.be\/)([^&?]+)/)?.[1] || '';
        stage.innerHTML = `<iframe src="https://www.youtube.com/embed/${vidId}?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
      } else if (item.url.includes('vimeo.com')) {
        const vidId = item.url.match(/vimeo\.com\/(\d+)/)?.[1] || '';
        stage.innerHTML = `<iframe src="https://player.vimeo.com/video/${vidId}?autoplay=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>`;
      } else {
        stage.innerHTML = `<video src="${escHtml(item.url)}" controls autoplay playsinline style="max-height:100%;max-width:100%"></video>`;
      }
    }

    // Thumbnails
    const thumbsEl = document.getElementById('vfad-lb-thumbs');
    thumbsEl.innerHTML = media.map((m, idx) => `
      <div class="vfad-lb-thumb ${idx === i ? 'is-active' : ''}" onclick="vfadLbGoto(${idx})">
        ${m.type === 'image' && m.thumbUrl
          ? `<img src="${escHtml(m.thumbUrl)}" alt="thumb ${idx + 1}">`
          : `<div class="vfad-lb-thumb__video-icon">▶</div>`
        }
      </div>
    `).join('');

    // Scroll active thumb into view
    const activeThumb = thumbsEl.querySelector('.is-active');
    if (activeThumb) activeThumb.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
  }

  window.vfadLbGoto = function (idx) {
    state.lbIndex = idx;
    renderLightbox();
  };

  /* --------------------------------------------------------
     KEYBOARD NAVIGATION
  -------------------------------------------------------- */
  document.addEventListener('keydown', function (e) {
    if (document.getElementById('vfad-lightbox').style.display === 'none') return;
    if (e.key === 'Escape') vfadCloseLightbox();
    if (e.key === 'ArrowLeft') vfadLbNav(-1);
    if (e.key === 'ArrowRight') vfadLbNav(1);
  });

  /* --------------------------------------------------------
     TOUCH SWIPE for lightbox
  -------------------------------------------------------- */
  let touchStartX = 0;
  document.getElementById('vfad-lightbox').addEventListener('touchstart', e => {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  document.getElementById('vfad-lightbox').addEventListener('touchend', e => {
    const dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) vfadLbNav(dx < 0 ? 1 : -1);
  }, { passive: true });

  /* --------------------------------------------------------
     UTILS
  -------------------------------------------------------- */
  function escHtml(str) {
    if (!str) return '';
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  // Make vfadShowHomeView accessible globally (used in breadcrumb onclick)
  window.vfadShowHomeView = vfadShowHomeView;

})();